import { getCSRFToken } from './django'
import { invalidateProjectData } from '../carbon/carbonApi'

const API_BASE = (process.env.REACT_APP_API_BASE || 'http://localhost:8000') + '/api/tti'

async function apiRequest (method, path, data, multipart = false) {
  const options = {
    method,
    headers: {
      Accept: 'application/json',
      'X-CSRFToken': getCSRFToken()
    },
    credentials: 'include'
  }
  if (data !== undefined) {
    if (!multipart) options.headers['Content-Type'] = 'application/json'
    options.body = multipart ? data : JSON.stringify(data)
  }
  const resp = await fetch(`${API_BASE}${path}`, options)
  if (!resp.ok) {
    const body = await resp.json().catch(() => ({}))
    const err = new Error(body.error || body.detail || `API error ${resp.status}`)
    err.status = resp.status
    err.body = body
    throw err
  }
  if (resp.status === 204) return null
  return resp.json()
}

export const getTtiHealth = () => apiRequest('GET', '/health/')
export const getTtiMe = () => apiRequest('GET', '/me/')

export function editingDraftApi (projectId) {
  const path = `/projects/${encodeURIComponent(projectId)}/editing-draft/`
  return {
    get: ({ calculate = false } = {}) => apiRequest('GET', path + `?calculate=${calculate}&compact=1`),
    put: (data, calculate = false) => apiRequest('PUT', path + `?calculate=${calculate}`, data),
    delete: (data) => apiRequest('DELETE', path, data),
    commit: async (data) => {
      invalidateProjectData()
      const response = await apiRequest('POST', path + 'commit/', data)
      invalidateProjectData()
      return response
    },
    report: (project) => apiRequest('POST', path + 'report/', { project }),
    import: (files, data) => {
      const form = new FormData()
      files.forEach(file => form.append('file', file))
      form.append('project', JSON.stringify(data.project))
      form.append('revision', data.revision === null ? 'null' : String(data.revision))
      form.append('base_updated_at', data.base_updated_at)
      return apiRequest('POST', path + 'bom-import/', form, true)
    }
  }
}
